import { CommandHandler, type PassThroughCommandProperties } from './types/command-handler-types';

export class AbortCommandHandler extends CommandHandler<void, void> {
	private onAbort: () => void;

	constructor(properties: PassThroughCommandProperties, onAbort: () => void) {
		super(properties);
		this.onAbort = onAbort;
	}

	listen(): Promise<void> {
		try {
			this.onAbort();
		} catch {
			// TODO: report this error
		}

		return Promise.resolve();
	}
}
